<template>
<div id="top-nav" class="fixed-top">
  <b-navbar type="light" :class="{'partition-nav': getClient.parent}">
    <div class="nav-toggle"
         name="button"
         @click="updateNavClass"
         qid="side-nav-toggle"
    >
      <font-awesome-icon icon="bars" />
    </div>

    <!-- Clients dropdown -->
    <div v-if="!getClient.parent" class="client-picker-container color-blue">
    <!-- <b-navbar-nav v-if="!getClient.parent" class="client-picker-container"> -->
      <!-- <b-nav-item-dropdown
          left
          :class="{'not-clickable': getClients && getClients.length < 1}"
          extra-toggle-classes="no-dropdown-caret client-picker ml-1"
          qid="navbar-client-dropdown"
      > -->
        <!-- Using 'button-content' slot -->
        <!-- <template slot="button-content" v-if="getClient"> -->
          <span class="small" style="padding-left: 5px;">
            {{ $t('administration.clients.label') }}
          </span>
          <!-- <div class="selected">
            <span class="mr-3">{{ getClient.name }}</span>
            <span v-if="getClients && getClients.length > 0">
              <font-awesome-icon
                  icon="caret-down"
                  class="float-right mt-1 color-blue small"
              />
            </span>
          </div> -->
          <multiselect
              v-model="client"
              :options="clients"
              :multiple="false"
              :taggable="false"
              :allow-empty="false"
              required
              select-label=""
              selected-label=""
              deselect-label=""
              @input="updateClient(client)"
              @search-change="debounceClients"
              :internalSearch="false"
              track-by="slug"
              :placeholder="$t('administration.clients.title')"
              label="name"
              qid="search-c-input"
          >
            <template slot="singleLabel" slot-scope="props">
              <Avatar :object="props.option" size="xs"></Avatar>
              <span class="ml-2">
                {{ props.option.name }}
              </span>
            </template>
            <template slot="option" slot-scope="props">
              <Avatar :object="props.option"
                      size="xs"
                      style="margin-right:10px;float:left;"
                      :class="{'pb-3': props.option.cvr && props.option.reference_number}"
              ></Avatar>
              <span class="">
                <div>{{ props.option.name }}</div>
                <span style="font-size:14px;color:#BCDAD4;" v-if="props.option.cvr">CRN: {{ props.option.cvr }}</span>
                <br v-if="props.option.cvr && props.option.reference_number">
                <span style="font-size:14px;color:#BCDAD4;" v-if="props.option.reference_number">REF: {{ props.option.reference_number }}</span>
              </span>
            </template>
          </multiselect>
        <!-- </template> -->
        <!-- <span v-if="getClients">
          <b-dropdown-item
              v-for="client in getClients"
              :key="client.id"
              @click="updateClient(client)"
          >
            <span>
              {{ client.name }}
            </span>
          </b-dropdown-item>
        </span> -->
      <!-- </b-nav-item-dropdown> -->
    <!-- </b-navbar-nav> -->
    </div>


    <!-- Back to parent client -->
    <div v-if="getClient.parent"
         class="cursor-pointer parent-client-button"
         @click="updateClient(getClient.parent)"
    >
        <span class="small color-blue ml-3">
          {{ $t('administration.clients.label') }}
        </span>
      <div class="">
        <h6 class=" mb-0 client-label"
            :class="{'ml-3': getUser.clients && getUser.clients.length == 1}"
        >
          <font-awesome-icon
              icon="angle-left"
              class="left mr-1"
          />
          <Avatar :object="getClient.parent" size="xs"></Avatar>
          {{ getClient.parent.name }}
        </h6>
      </div>
    </div>


    <!-- Partitions dropdown -->
    <div class="client-picker-container color-blue" :class="{'not-clickable': partitions && partitions.length < 1}" style="padding-left: 30px;">
    <!-- <b-navbar-nav class="client-picker-container" v-if="partitions && partitions.length"> -->
      <!-- <b-nav-item-dropdown
          left
          extra-toggle-classes="no-dropdown-caret client-picker ml-1"
          :class="{'not-clickable': partitions && partitions.length < 1}"
          qid="navbar-client-dropdown"
      > -->
        <!-- Using 'button-content' slot -->
        <!-- <template slot="button-content" v-if="getClient"> -->
          <span class="small" style="padding-left: 5px;">
            {{ $t('administration.partitions.label') }}
          </span>
          <multiselect
              v-model="partition"
              :options="partitions"
              :multiple="false"
              :taggable="false"
              @remove="updateClient(getClient.parent)"
              required
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              @input="updateClient(partition)"
              @search-change="debouncePartitions"
              :internalSearch="false"
              track-by="slug"
              :placeholder="$t('administration.partitions.select')"
              label="name"
              qid="search-p-input"
          >
          <template slot="singleLabel" slot-scope="props">
            <Avatar :object="props.option" size="xs"></Avatar>
            <span class="ml-2">
              {{ props.option.name }}
            </span>
          </template>
            <template slot="option" slot-scope="props">
              <Avatar :object="props.option"
                      size="xs"
                      style="margin-right:10px;float:left;"
                      :class="{'pb-3': props.option.cvr && props.option.reference_number}"
              ></Avatar>
              <span class="">
                <div>{{ props.option.name }}</div>
                <span style="font-size:14px;color:#BCDAD4;" v-if="props.option.cvr">CRN: {{ props.option.cvr }}</span>
                <br v-if="props.option.cvr && props.option.reference_number">
                <span style="font-size:14px;color:#BCDAD4;" v-if="props.option.reference_number">REF: {{ props.option.reference_number }}</span>
              </span>
            </template>
          </multiselect>
          <!-- <div class="selected">
            <span class="mr-3" v-if="getClient.parent">
              {{ getClient.name }}
            </span>
            <span v-if="!getClient.parent" class="mr-3">
              {{ $t('administration.partitions.select') }}
            </span>
            <span v-if="partitions && partitions.length > 0">
              <font-awesome-icon
                  icon="caret-down"
                  class="float-right mt-1 color-blue small"
              />
            </span>
          </div> -->
        <!-- </template> -->
        <!-- <span v-if="partitions">
          <b-dropdown-item
              v-for="client in partitions"
              :key="client.id"
              @click="updateClient(client)"
          >
            <span>
              {{ client.name }}
            </span>
          </b-dropdown-item>
        </span> -->
      <!-- </b-nav-item-dropdown>
    </b-navbar-nav> -->
    </div>


    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto navbar-right" style="width:320px;">

      <router-link
          v-b-tooltip.hover :title="$t('maintenance.reports.title')"
          class="nav-link"
          :to="{name: 'maintenance.reports'}"
          qid="reports-link"
          v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        <font-awesome-icon icon="file-download" />
      </router-link>

      <router-link
          v-b-tooltip.hover :title="$t('maintenance.title')"
          class="nav-link"
          to="/maintenance"
          qid="navbar-maintenance-link"
          v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        <font-awesome-icon icon="cog" />
      </router-link>

      <Notifications></Notifications>

      <!-- Activity switch -->
      <a v-b-tooltip.hover
         :title="$t('top_nav.activity_log')"
         class="nav-link"
         qid="navbar-activity-link"
         @click="updateActivityClass"
      >
        <font-awesome-icon icon="wave-square" />
      </a>

      <div v-if="showLanguageOptions" style="" class="dropdown-submenu">
        <div class="dropdown-item cursor-pointer" v-for="item in langOptions" @click="selectLanguage(item)">
          <div>
            <img width="20px" height="20px" src="@/assets/en.png" v-if="item.value == 'en'">
            <img width="20px" height="20px" src="@/assets/da.png" v-if="item.value == 'da'">
            <img width="20px" height="20px" src="@/assets/fr.png" v-if="item.value == 'fr'">
            <img width="20px" height="20px" src="@/assets/de.png" v-if="item.value == 'de'">
            <span class="ml-1">
              {{ item.title }}
            </span>
          </div>
        </div>
      </div>

      <b-nav-item-dropdown
          right
          @hide="showLanguageOptions = false"
          extra-gle-classes="no-dropdown-caret"
          qid="navbar-user-dropdown"
          class="user-dropdown"
      >
        <!-- Using 'button-content' slot -->
        <template slot="button-content" qid="user-dropdown">
          <img :src="getProfileAvatar()"
               class="rounded-circle"
               width="30"
               height="30"
               qid="profile-photo"
          >
        </template>
        <router-link
            :to="{ name: 'profile', params: { slug: getUser.slug }}"
            qid="user-dropdown-profile-link"
            class="dropdown-item dropdown-item--link"
        >
          {{ $t('top_nav.user_dropdown.my_profile') }}
          <br>
          <small class="text-muted">{{ getUser.name }}</small>
        </router-link>
        <b-dropdown-divider></b-dropdown-divider>
        <div class="dropdown-item cursor-pointer" @click="handleLanguageOptions">
          <img width="20px" height="20px" src="@/assets/en.png" v-if="selectedLang.value == 'en'">
          <img width="20px" height="20px" src="@/assets/da.png" v-if="selectedLang.value == 'da'">
          <img width="20px" height="20px" src="@/assets/fr.png" v-if="selectedLang.value == 'fr'">
          <img width="20px" height="20px" src="@/assets/de.png" v-if="selectedLang.value == 'de'">
          <span class="ml-1">
            {{ selectedLang.title }}
          </span>
        </div>
        <b-dropdown-divider v-if="isGranted(permissions.MAINTENANCE_VIEW)"></b-dropdown-divider>
        <router-link
            :to="{ name: 'clientProfile', params: { slug: getClient.slug }}"
            qid="user-dropdown-profile-link"
            v-if="isGranted(permissions.MAINTENANCE_VIEW)"
            class="dropdown-item dropdown-item--link"
        >
          <span v-if="getClient.parent">
            {{ $t('top_nav.user_dropdown.partition_profile') }}
          </span>
          <span v-if="!getClient.parent">
            {{ $t('top_nav.user_dropdown.client_profile') }}
          </span>
          <br>
          <small class="text-muted">
            {{ getClient.name }}
          </small>
        </router-link>
        <b-dropdown-divider></b-dropdown-divider>
        <router-link
            to="/administration"
            qid="user-dropdown-administration-link"
            v-if="checkAdmin(permissions.ROLE_SUPER_ADMIN)"
            class="dropdown-item dropdown-item--link"
        >
          {{ $t('top_nav.user_dropdown.administration') }}
        </router-link>
        <b-dropdown-divider v-if="checkAdmin(permissions.ROLE_SUPER_ADMIN)"></b-dropdown-divider>
        <b-dropdown-item @click="logout" qid="user-dropdown-logout">
          {{ $t('top_nav.user_dropdown.logout') }}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>

  <div class="trial-badge" v-if="getClient.subscription_status == 'trial'">
    <router-link :to="{ name: 'clientProfile', params: { slug: getClient.slug }, query: { tabindex: 1 }}">
      {{ $t('profile.client.billing.trial_label') }}
      {{ $t('profile.client.billing.expires_in') }}
      {{ getDifference(getClient.trial_ends_at) + 1 }}
      {{ $t('system.days') }}
    </router-link>
  </div>
  <div class="trial-expired-badge" v-if="getClient.subscription_status == 'trial_expired'">
    <router-link :to="{ name: 'clientProfile', params: { slug: getClient.slug }, query: { tabindex: 1 }}">
      {{ $t('profile.client.billing.trial_expired_label') }}
    </router-link>
  </div>

</div>
</template>

<script>
import piincHttp from '../util/configureAxios.js'
import permissionMap from '../util/ACL/permissionMap.js'
import {config} from '@/config.js'
import permissionCheck from "../util/ACL/permissionCheck";
import Avatar from '@/components/Avatar.vue';
import Notifications from '@/components/notification/Notifications.vue';

export default {
  name: 'TopNavigation',
  data: function() {
    return {
      user: this.$store.state.user,
      reloadActivity: false,
      client: "",
      partition: "",
      partitions: [],
      clients: [],
      selectedLang: [],
      langOptions: [
        {value: 'en', title: 'English'},
        {value: 'da', title: 'Dansk'},
        {value: 'fr', title: 'French'},
        {value: 'de', title: 'German'}
      ],
      showLanguageOptions: false,
    }
  },
  computed: {
    getUser() {
      return this.$store.state.user
    },
    getClients() {
      let clients = [];
      if (this.$store.state.user.clients) {
        for (var i = 0; i < this.$store.state.user.clients.length; i++) {
          if (!this.$store.state.user.clients[i].parent){
            clients.push(this.$store.state.user.clients[i]);
          }
        }
        if (clients && clients.length) {
          clients.sort(function(a, b) {
            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
        }
      }
      return clients
    },
    getClient() {
      return this.$store.state.client
    }
  },
  components:{
    Notifications,
    Avatar
  },
  watch: {
    getClient: function (value) {
      if (value && value.slug) {
        this.loadPartitions();
      }
    },
    getUser: function (value) {
      if (value) {
        if (this.getClient && this.getClient.slug) {
          this.loadPartitions();
        }
      }
    }
  },
  methods: {
    debounceClients: _.debounce(function(keyword) {
      this.loadClients(keyword)
    }, 500),
    debouncePartitions: _.debounce(function(keyword) {
      this.loadPartitionsSearch(keyword)
    }, 500),
    updateNavClass() {
      // Update top level class to collapsed
      let topElement = document.getElementById("app");
      topElement.classList.toggle("sidebar-collapsed");
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment()
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    isMemberOfClient(client) {
      let isMember = false;
      if (this.$store.state.user.clients) {
        for (var i = 0; i < this.$store.state.user.clients.length; i++) {
          if (this.$store.state.user.clients[i].slug == client.slug){
            isMember = true;
          }
        }
      }
      return isMember;
    },
    handleLanguageOptions(evt) {
      evt.stopPropagation()
      this.showLanguageOptions = !this.showLanguageOptions
    },
    selectLanguage(item) {
      localStorage.setItem('lang', item.value)
      window.location.reload()
    },
    loadPartitions(query) {
      let self = this;
      piincHttp.get('partitions', { params: {
        client: self.getClient.parent ? self.getClient.parent.slug : self.getClient.slug,
        per_page: 0,
        sort: 'name',
        order: 'asc',
        mine: !this.getUser.isAdmin ? 1 : undefined
      }}).then(function(response) {
        self.partitions = response.data.items;

        if (self.getClient.parent) {
          self.client = self.getClient.parent;
          self.partition = self.getClient;
        } else {
          self.client = self.getClient;
          self.partition = [];
        }
      }, function() {});
    },
    loadPartitionsSearch(query) {
      let self = this;
      piincHttp.get('partitions', { params: {
        client: self.getClient.parent ? self.getClient.parent.slug : self.getClient.slug,
        per_page: 0,
        sort: 'name',
        order: 'asc',
        keyword: query ? query : undefined,
        mine: !this.getUser.isAdmin ? 1 : undefined
      }}).then(function(response) {
        self.partitions = response.data.items;
      }, function() {});
    },
    loadClients(query) {
      let self = this;
      piincHttp.get('clients', { params: {
        per_page: 100,
        without_partition: 1,
        member: !this.getUser.isAdmin ? this.getUser.id : undefined,
        keyword: query ? query : undefined
      }}).then(function(response) {
        self.clients = response.data.items;
      }, function() {});
    },
    updateActivityClass() {
      this.reloadActivity = !this.reloadActivity;
      // Update top level class to collapsed only if main navigation
      let topElement = document.getElementById("app");
      topElement.classList.toggle("activity-collapsed");
      if (!topElement.classList.contains("guide-collapsed")) {
        topElement.classList.toggle("guide-collapsed");
        this.$store.commit('storeHelpCenterState', false);
      }
      this.$emit('reloadActivity', this.reloadActivity);
    },
    updateClient(client) {
      let self = this;
      let selectedClient = client;
      piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
        selectedClient.user_permissions = response.data.user_permissions
        selectedClient.user_roles = response.data.user_roles
        localStorage.setItem('clientObject', JSON.stringify(selectedClient));
        localStorage.setItem('client', selectedClient.slug);
        self.$store.commit('storeClient', selectedClient);
      }, function() {});
    },
    logout() {
      let self = this;
      piincHttp.post('logout').then(function() {
        localStorage.removeItem('token')
        localStorage.removeItem('client')
        localStorage.removeItem('clientObject')
        self.$store.commit('storeHistoryPage', '');
        setTimeout( function () {
          window.location.href = '/login'
        }, 500);
      }, function(error) {
        alert(error)
      })
    },
    getProfileAvatar(){
      let user = this.$store.state.user;
      let link = ''
      if (user.avatar) {
        return user.avatar;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    checkAdmin(role) {
      let hasRole = false;
      let user = this.$store.state.user;
      if (user.isAdmin) {
        hasRole = true;
      }
      // Return Boolean if user has given role
      return hasRole;
    },
  },
  created() {
    let self = this;

    this.loadClients();

    if (this.getClient && this.getClient.slug) {
      this.loadPartitions();
    }

    if (localStorage.getItem('lang')) {
      _.find(self.langOptions, function(item) {
        if (item.value === localStorage.getItem('lang')) {
          self.selectedLang = item;
        }
      });
    } else {
      this.selectedLang = this.langOptions[0]
    }
  }
}
</script>
